import { Storefront } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const FeedbackSection = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.infrastructure.feedback.title" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/feedback">
          <List.ItemIcon>
            <Storefront />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.dashboard.infrastructure.feedback.form" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </StyledPaper>
  );
};
